import DashboardLayout from "@/layout/dashboard/DashboardLayout.vue";
// GeneralViews
import NotFound from "@/pages/NotFoundPage.vue";

// Admin pages
// import Dashboard from "@/pages/Dashboard.vue";
import ProductsList from "@/pages/ProductsList.vue";
import AddProduct from "@/pages/AddProduct.vue";
import ResetPassword from "@/pages/ResetPassword.vue"

const routes = [{
    path: "/",
    component: DashboardLayout,
    // redirect: "/dashboard",
    redirect: "/products-list",
    children: [
      // {
      //   path: "dashboard",
      //   name: "Dashboard",
      //   component: Dashboard
      // },

      {
        path: "products-list",
        name: "Produtos",
        component: ProductsList
      },

      {
        path: "add-product",
        name: "Cadastro de Produtos",
        component: AddProduct
      },
    ]
  },

  {
    path: "/reset-password",
    name: "Redefinição de Senha",
    component: ResetPassword
  },

  {
    path: "*",
    component: NotFound
  }
];

/**
 * Asynchronously load view (Webpack Lazy loading compatible)
 * The specified component must be inside the Views folder
 * @param  {string} name  the filename (basename) of the view to load.
function view(name) {
   var res= require('../components/Dashboard/Views/' + name + '.vue');
   return res;
};**/

export default routes;
